import httpClient from 'api/core/httpClient';
import { ENDPOINTS } from 'api/config/endpoints';
import auth from 'api/core/auth';

class AuthApi {
  constructor() {
    this.httpClient = httpClient;
    this.resource = ENDPOINTS.AUTH;
  }

  getResourceUrl() {
    return `p/${this.resource}/`;
  }

  async login(credentials) {
    const resp = await this.httpClient.post(`p/auth/login/`, credentials, {
      withCredentials: true,
    });

    return resp;
  }

  async logout(credentials) {
    try {
      const response = await this.httpClient.get(
        `${this.getResourceUrl()}logout/`,
        credentials,
        {
          withCredentials: true,
        },
      );
      auth.clearAuth();
      return response;
    } catch (error) {
      auth.clearAuth();
      throw error;
    }
  }

  async passwordReset(data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}password-reset/`,
      data,
    );
  }

  async passwordResetConfirm(data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}password-reset/confirm/`,
      data,
    );
  }
}

export default new AuthApi();
